import {v4 as uuid} from 'uuid';
import {fileDropHandlerKey} from '../plugins/fileDropHandler';
import {fileUpload} from '../../Common/fileUpload';

import 'fomantic-ui-less/definitions/modules/toast.less';
import 'fomantic-ui-less/definitions/modules/toast';
import prettyBytes from 'pretty-bytes';
import {escapeHtml} from '../../Common/escapeHtml';

export const friendlyBytes = size => {
    let parsed = parseInt(size, 0);
    if (isNaN(parsed)) {
        parsed = 0;
    }
    return prettyBytes(parsed, {maximumFractionDigits: 1});
}

export const mediaSizeFit = (imageWidth, imageHeight, maxWith, maxHeight) => {
    const widthRatio = maxWith / imageWidth;
    const heightRatio = maxHeight / imageHeight;

    let ratio = Math.min(widthRatio, heightRatio);
    if (maxWith > imageWidth && maxHeight > imageHeight) {
        ratio = Math.max(widthRatio, heightRatio);
    }

    return {
        width: Math.max(Math.round(imageWidth * ratio), 0),
        height: Math.max(Math.round(imageHeight * ratio), 0)
    }
}

export const isAudioFile = file => file && ['audio/3gpp', 'audio/3gpp2', 'audio/3gp2', 'audio/flac', 'audio/x-flac', 'audio/mpeg', 'audio/mp4', 'audio/ogg', 'audio/wave', 'audio/wav', 'audio/x-wav', 'audio/x-pn-wav', 'audio/webm'].includes(file.type);

export const isVideoFile = file => file && ['video/3gpp', 'video/3gpp2', 'video/3gp2', 'video/mpeg', 'video/mp4', 'video/ogg', 'application/ogg', 'video/quicktime', 'video/webm'].includes(file.type);

export const isImageFile = file => file && ['image/png', 'image/jpeg', 'image/gif', 'image/svg+xml', 'image/apng', 'image/avif', 'image/avif'].includes(file.type);

const findPlaceholder = (state, id) => {
    let decorationSet = fileDropHandlerKey.getState(state);
    let found = decorationSet.find(null, null, spec => spec.id === id);
    return found.length ? found[0].from : null;
}

const truncateString = (str = '', num) => {
    if (str.length <= num) {
        return str
    }
    return str.slice(0, num) + '...';
}

const displayToast = (type, message) => {
    $('body').toast({
        class: type,
        className: {
            toast: 'ui message'
        },
        displayTime: 5000,
        message
    });
}

export const uploadFile = (url, file, view, diagram, successCallback) => {
    const id = uuid();
    if (!view.state.tr.selection.empty) {
        view.state.tr.deleteSelection();
    }
    view.dispatch(view.state.tr.setMeta(fileDropHandlerKey, {add: {id, file, pos: view.state.tr.selection.from}}));

    const fileNameTruncated = truncateString(file.name, 15);
    const pos = findPlaceholder(view.state, id);
    if (pos == null) {
        return;
    }

    const title = escapeHtml(file.name);

    fileUpload(url, file).then(response => {
        if (response.status === 200) {
            if (isImageFile(file)) {
                const fileId = response.json;
                const image = new Image();
                image.src = `${url}/${fileId}`;
                image.addEventListener('load', () => {
                  const {left, right} = view.dom.getBoundingClientRect();
                  const largeSize = mediaSizeFit(image.naturalWidth,
                      image.naturalHeight, right - left, image.naturalHeight);
                  const transaction = view.state.tr.replaceWith(pos, pos,
                      view.state.schema.nodes.image.create({
                        src: `${url}/${fileId}`,
                        width: largeSize.width,
                        height: largeSize.height,
                        ['data-id']: fileId,
                        ['data-diagram']: diagram,
                      }, view.state.schema.text(file.name)));
                  view.dispatch(transaction);

                  if (successCallback && typeof successCallback === "function") {
                    successCallback(pos);
                  }
                });
                view.dispatch(view.state.tr.setMeta(fileDropHandlerKey, {remove: {id}}));
            } else {
                const fileId = response.json;
                const transaction = view.state.tr
                    .replaceWith(pos, pos, view.state.schema.text(fileNameTruncated))
                    .addMark(
                        pos,
                        pos + fileNameTruncated.length,
                        view.state.schema.marks.link.create({
                            ['data-id']: fileId,
                            ['data-size']: file.size,
                            ['data-type']: file.type,
                            title,
                            href: `${url}/${fileId}`
                        })
                    ).setMeta(fileDropHandlerKey, {remove: {id}});
                view.dispatch(transaction);

                if (successCallback && typeof successCallback === "function") {
                  successCallback(pos);
                }
            }

            displayToast('success', `File ${title} - ${friendlyBytes(file.size)} uploaded successfully.`);
        } else {
          const transaction = view.state.tr.replaceWith(pos, pos,
              view.state.schema.text(fileNameTruncated)).addMark(
              pos,
              pos + fileNameTruncated.length,
              view.state.schema.marks.link.create({
                ['data-id']: id,
                ['data-size']: file.size,
                ['data-type']: file.type,
                error: true,
                title,
                href: `${url}/${id}`,
              }),
          ).setMeta(fileDropHandlerKey, {remove: {id}});
          view.dispatch(transaction);

          if (response.status === 400) {
            if (response.json) {
                displayToast('error', `We're unable to upload the file ${title}. ${escapeHtml(response.json.message)}`);
            } else {
                displayToast('error', `We're unable to upload the file ${title}. ${escapeHtml(response.text)}`);
            }
          } else {
            displayToast('error', `We're unable to upload the file ${title}, please try again.`);
          }
        }
    }).catch(() => {
        const transaction = view.state.tr
            .replaceWith(pos, pos, view.state.schema.text(fileNameTruncated))
            .addMark(
                pos,
                pos + fileNameTruncated.length,
                view.state.schema.marks.link.create({
                    ['data-id']: id,
                    ['data-size']: file.size,
                    ['data-type']: file.type,
                    error: true,
                    title,
                    href: `${url}/${id}`
                })
            )
            .setMeta(fileDropHandlerKey, {remove: {id}});
        view.dispatch(transaction);

        displayToast('error', `We're unable to upload the file ${title}, please try again.`);
    });
}